import React from 'react';

interface Props {
  label: string;
  showX: boolean;
  onXClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const Badge: React.FC<Props> = (props) => {
  const { label, showX, onXClick } = props;

  return (
    <span className="inline-flex items-center rounded-full bg-gray-100 py-0.5 pl-2 pr-0.5 m-0.5 text-xs font-medium text-gray-700">
      <span className="truncate">{label}</span>
      {showX && (
        <button
          type="button"
          onClick={onXClick}
          className="ml-0.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full hover:bg-blue-300 hover:text-blue-600 focus:bg-blue-700 focus:text-white focus:outline-none"
        >
          <span className="sr-only">Remove {label}</span>
          <svg className="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
            <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
          </svg>
        </button>
      )}
    </span>
  );
};
Badge.displayName = 'Badge';
